import { useEffect, useState } from 'react'
import { Grid } from '@mui/material'

import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import FacebookTabs, { FacebookTabsEnum } from './components/FacebookTabs'
import CircularLoading from '../../../../components/CircularProgress'
import FacebookReplyChat from './components/FacebookReplyChat'
import FacebookDiggerChat from './components/FacebookDiggerChat'
import FacebookSettingChat from './components/FacebookSettingChat'
import { useUser } from '../../../../hooks/useUser'
import PageUrls from '../../../../constants/page-urls'

const Menus = [
  {
    breadcrumbName: 'แชท Facebook',
    title: 'แชท Facebook',
    path: PageUrls.Chat.Facebook
  },
]

const FacebookPage = () => {
  const [tab, setTab] = useState<FacebookTabsEnum>(FacebookTabsEnum.ReplyChat)
  const { user, merchant } = useUser()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const getMerchant = async () => {
      setIsLoading(true)
      if (!merchant.facebookAccessToken) {
        setTab(FacebookTabsEnum.Setting)
      }
      setIsLoading(false)
    }
    getMerchant()
  }, [merchant])

  return (
    <ContentWrapper>
      <CircularLoading isLoading={isLoading} />
      <Helmet title="แชท Facebook" />
      <Grid
        container
        justifyContent="space-between"
        alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="แชท Facebook"
            routes={Menus}
            descriptions="แชท Facebook"
          />
        </Grid>
        <Grid item mb={2}>
          <FacebookTabs
            tab={tab}
            onChangTab={(newTab: FacebookTabsEnum) => setTab(newTab)}
            disabled={{
              [FacebookTabsEnum.ReplyChat]: !merchant.facebookAccessToken,
              [FacebookTabsEnum.DigChat]: !merchant.facebookAccessToken,
            }}
          />
        </Grid>
      </Grid>
      {
        tab === FacebookTabsEnum.ReplyChat ? (
          <FacebookReplyChat />
        ) : tab === FacebookTabsEnum.DigChat ? (
          <FacebookDiggerChat />
        ) : (
          <FacebookSettingChat
            isLoginFacebook={!!merchant.facebookAccessToken}
          />
        )
      }
    </ContentWrapper>
  )
}
export default FacebookPage